module.exports = __webpack_public_path__ + "media/assets/images/nosco_cloud-f4e4b727401d0827684c152ccd81b5a6.png";